import React from "react";
import { Link } from "react-router";

type Props = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

function removeTrailingSlash(url?: string) {
  if (!url) return "#";
  if (url === "/") return url;
  return url.replace(/\/$/, "");
}

function checkProtocol(url?: string) {
  if (!url) return url;
  if (!url.startsWith("http")) return `https://${url}`;
  return url;
}

const BaseLink = React.forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const external = isExternalLink(props.href || "#");

  if (!props.href) {
    return props.children
  }

  if (external) {
    return (
      <a
        rel="noopener noreferrer"
        {...props}
        href={checkProtocol(removeTrailingSlash(props.href))}
        target="_blank"
        ref={ref}
      >
        {props.children}
      </a>
    );
  }

  return (
    <Link ref={ref} to={removeTrailingSlash(props.href || "#")} {...props}>
      {props.children}
    </Link>
  );
});

export function isExternalLink(link: string): boolean {
  return !["/", "#"].includes(link.charAt(0)) ? true : false;
}

export default BaseLink;
